var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiLabelWideLilac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229.087,
    height: 55.891,
    viewBox: "0 0 229.087 55.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_Label_wide_lilac",
    d: "M9.656,3.375,3.64,2.094,0-25.411v-17.64l3.64-9.465L224.484-51.5l4.6,5.984-4.6,47.612L160.368,3.375",
    transform: "translate(0 52.515)",
    fill: "#826c9f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLabelWideLilac);
export default __webpack_public_path__ + "static/media/UI_Label_wide_lilac.92dc1359440f13959ebe07de3a4054cf.svg";
export { ForwardRef as ReactComponent };